/* eslint-disable camelcase */
<template>
  <div v-role="'func'">
    <v-overlay :value="overlay || $store.state.loading_pdf">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <br />
    <div>
      <div class="formPosition">
        <v-card style="margin: auto" width="1220">
          <v-container
            style="background-color: #006699; color: white"
          ></v-container>
          <v-progress-linear
            v-if="progresso"
            indeterminate
            color="green"
            height="10"
          ></v-progress-linear>

          <div class="top_info_container" v-if="isTelaPagamento">
            <div></div>
            <v-toolbar-title class="pagamento_feito">
              Pagamento Feito com sucesso!</v-toolbar-title
            >
            <div></div>
          </div>

          <div class="top_info_container" v-if="!isTelaPagamento">
            <v-btn
              @click="$router.push('/esc-pagamento')"
              style="background-color: #006699; color: white"
              outlined
            >
              <v-icon md color="white darken-2">add</v-icon> Novo Pagamento
            </v-btn>
            <v-toolbar-title class="titulo_pagina">
              Pagamentos Feitos</v-toolbar-title
            >
            <div></div>
          </div>

          <div class="top_info_search_container" v-if="!isTelaPagamento">
            <input
              type="text"
              v-model="searchInDb"
              placeholder="Pesquise pelo nome estudante, Nº Matrícula"
              append-icon="search"
              label="Pesquise pelo nome estudante, Nº Matrícula"
              single-line
              hide-details
              class="input_search"
            />
            <v-btn
              class="input_search_btn"
              small
              fab
              color="green"
              v-if="searchInDb !== ''"
              @click="initialize()"
              style="background-color: yellow; color: white"
              ><v-icon>search</v-icon></v-btn
            >
          </div>

          <template>
            <v-data-table
              :headers="headers"
              :items="dispesas"
              :search="searchInDb"
            >
              <template v-slot:item.valorAPagar="{ item }">
                <span>{{
                  utilitarios.IntegerToMoneyValueFatura(item.valorAPagar)
                }}</span>
              </template>
              <template v-slot:item.iva="{ item }">
                <span>{{
                  utilitarios.IntegerToMoneyValueFatura(item.iva)
                }}</span>
              </template>
              <template v-slot:item.valorIliquido="{ item }">
                <span>{{
                  utilitarios.IntegerToMoneyValueFatura(item.valorIliquido)
                }}</span>
              </template>
              <template v-slot:item.ordem="{ item }">
                <span>{{ dispesas.indexOf(item) + 1 }}</span>
              </template>
              <template v-slot:item.estado="{ item }">
                <span
                  v-if="item.estado === 'Anulada' && item.fkTipoDocumento !== 4"
                  style="color: red"
                  >{{ item.estado }}</span
                >
                <span
                  v-if="item.estado !== 'Anulada' && item.fkTipoDocumento !== 4"
                  style="color: green"
                  >{{ item.estado }}</span
                >
              </template>
              <template v-slot:item.action="{ item }">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      fab
                      dark
                      small
                      color="#006699"
                      v-bind="attrs"
                      v-on="on"
                      @click="CarregarItemsTabela(item)"
                    >
                      <v-icon dark>list</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver mais detalhes</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </template>
          <hr />
          <template>
            <v-row>
              <v-col md="4">
                <span
                  style="margin-left: 54px; font-size: 18px; font-weight: bold"
                  >Nº de movimentações:
                  <v-chip>{{ dispesas.length }}</v-chip>
                </span>
              </v-col>
              <v-col md="4"> </v-col>
              <v-col md="4">
                <span
                  >Valor Total:
                  <v-chip color="#006699" style="color: white"
                    >{{ utilitarios.IntegerToMoneyValueFatura(totalDebito) }}
                  </v-chip></span
                >
              </v-col>
            </v-row>
          </template>
          <!-- ====================================== Card ========================================== -->

          <template>
            <v-row justify="center">
              <v-dialog v-model="dialog" persistent max-width="1000px">
                <v-card>
                  <v-overlay :value="$store.state.loading_pdf">
                    <v-progress-circular
                      indeterminate
                      size="64"
                    ></v-progress-circular>
                  </v-overlay>
                  <v-card-title style="background-color: #006699; color: white">
                    <span class="text-h5">Detalhes da Fatura</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col md="8">
                          <div style="border: 1px solid #ccc">
                            <v-row style="margin-left: 10px">
                              <v-col md="6"
                                ><span style="font-weight: bold; size: 18px"
                                  >Identificação:</span
                                >
                                <v-chip class="ma-2" style="font-size: 12px">
                                  {{
                                    editedItem !== null
                                      ? editedItem.numeroDocumento
                                      : ""
                                  }}</v-chip
                                >
                              </v-col>
                              <v-col md="6"
                                ><span style="font-weight: bold; size: 18px"
                                  >Cliente:</span
                                >
                                <v-chip class="ma-2" style="font-size: 12px">
                                  {{
                                    editedItem !== null
                                      ? editedItem.cliente
                                      : ""
                                  }}</v-chip
                                >
                              </v-col>
                              <v-col md="8"
                                ><span style="font-weight: bold; size: 18px"
                                  >Data de operação:</span
                                >
                                <v-chip style="font-size: 12px">
                                  {{
                                    editedItem !== null
                                      ? editedItem.data_movimentacao
                                      : ""
                                  }}</v-chip
                                >
                              </v-col>
                              <v-col md="4"
                                ><span style="font-weight: bold; size: 18px"
                                  >Registrado por:</span
                                >
                                <v-chip style="font-size: 12px">
                                  {{
                                    editedItem !== null
                                      ? editedItem.nomeUsuario
                                      : ""
                                  }}</v-chip
                                >
                              </v-col>
                              <v-col md="4"
                                ><span style="font-weight: bold; size: 18px"
                                  >Curso:</span
                                >
                                <v-chip style="font-size: 12px">
                                  {{ estudante.curso }}
                                </v-chip>
                              </v-col>
                              <v-col md="4"
                                ><span style="font-weight: bold; size: 18px"
                                  >Anoacadémico:</span
                                >
                                <v-chip style="font-size: 12px">
                                  {{ estudante.classe }}
                                </v-chip>
                              </v-col>
                              <v-col md="4"
                                ><span style="font-weight: bold; size: 18px"
                                  >Turma:</span
                                >
                                <v-chip style="font-size: 12px">
                                  {{
                                    lastInscricaoNaTurma.length
                                      ? lastInscricaoNaTurma[0].turma
                                      : ""
                                  }}
                                </v-chip>
                              </v-col>
                            </v-row>
                          </div>
                        </v-col>
                        <v-col md="4">
                          <v-row>
                            <v-col md="3"></v-col>
                            <!-- <v-col md="3" v-if="isAdminSoftline">
                              
                              <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn v-bind="attrs" v-on="on" @click="showEditarDocumento()"  color="blue"><v-icon style="color:white;">edit</v-icon></v-btn>
                                </template>
                                <span>Editar Factura</span>
                              </v-tooltip>
                            </v-col> -->
                            <v-col md="3" v-if="isAdminSoftline">
                              <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="showAnularDocumento()"
                                    color="red"
                                    ><v-icon style="color: white"
                                      >delete</v-icon
                                    ></v-btn
                                  >
                                </template>
                                <span>Anular a Fatura</span>
                              </v-tooltip>
                            </v-col>
                            <v-col md="3">
                              <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    color="green"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="Impressao()"
                                  >
                                    <v-icon style="color: white">print</v-icon>
                                  </v-btn>
                                </template>
                                <span>Ré-imprimir a fatura</span>
                              </v-tooltip>
                            </v-col>
                            <!-- <v-col md="3">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <input @change="previewImage" type="file" :disabled="arrayFicheiros.length === 5" ref="file" style="display: none">
                                  <v-btn v-bind="attrs" v-on="on" @click="$refs.file.click()" :disabled="arrayFicheiros.length === 5">
                                    <v-icon>add_a_photo</v-icon>
                                  </v-btn>
                                </template>
                                <span>Anexar comprovativos</span>
                              </v-tooltip>
                            </v-col> -->
                          </v-row>
                        </v-col>
                        <v-col md="12">
                          <v-tabs v-model="tab">
                            <v-tab v-for="item in items" :key="item.tab">
                              {{ item.tab }}
                              <v-icon small>{{ item.icon }}</v-icon>
                            </v-tab>
                          </v-tabs>

                          <v-tabs-items v-model="tab">
                            <v-tab-item>
                              <v-card flat>
                                <v-card-text>
                                  <span
                                    style="font-weight: bold; font-size: 15px"
                                    >Items da Fatura</span
                                  ><br />
                                  <hr />
                                  <template>
                                    <v-data-table
                                      :headers="headersItems"
                                      :items="itemsFatura"
                                    >
                                      <template
                                        v-slot:item.precoUnitario="{ item }"
                                      >
                                        <span>{{
                                          utilitarios.IntegerToMoneyValueFatura(
                                            item.precoUnitario
                                          )
                                        }}</span>
                                      </template>

                                      <template v-slot:item.fkMes="{ item }">
                                        <span>
                                          {{
                                            utilitarios.getMonthDescription(
                                              item.fkMes
                                            )
                                          }}
                                        </span>
                                      </template>

                                      <template v-slot:item.subTotal="{ item }">
                                        <span>{{
                                          utilitarios.IntegerToMoneyValueFatura(
                                            item.subTotal
                                          )
                                        }}</span>
                                      </template>
                                      <template v-slot:item.ordem="{ item }">
                                        <span>{{
                                          itemsFatura.indexOf(item) + 1
                                        }}</span>
                                      </template>
                                      <template v-slot:item.estado="{ item }">
                                        <span
                                          v-if="item.estado === 'Anulada'"
                                          style="color: red"
                                          >{{ item.estado }}</span
                                        >
                                        <span
                                          v-if="item.estado !== 'Anulada'"
                                          style="color: green"
                                          >{{ item.estado }}</span
                                        >
                                      </template>
                                      <!-- <template v-slot:item.action="{ item }">
                                        <v-tooltip left>
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-btn fab dark x-small color="red" v-bind="attrs" v-on="on"
                                              @click="dialog = false; item_venda = item; dialogAnularMulta = true"
                                              v-if="(roleUsuario === 'ROLE_SPG' || roleUsuario === 'ROLE_ADM' || roleUsuario === 'SUPER_USER') && item.isPropina">
                                              <i class="fa fa-ban"></i>
                                            </v-btn>
                                          </template>
                                          <span>Anular multa</span>
                                        </v-tooltip>
                                      </template> -->
                                    </v-data-table>
                                  </template>
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                            <v-tab-item>
                              <v-card flat>
                                <v-card-text>
                                  <span
                                    style="font-weight: bold; font-size: 15px"
                                    >Comprovativos carregados</span
                                  ><br />
                                  <hr />
                                  <template>
                                    <v-data-table
                                      :headers="headerComprovativos"
                                      :items="comprovativos"
                                    >
                                      <template v-slot:item.view="{ item }">
                                        <v-tooltip bottom>
                                          <template
                                            v-slot:activator="{ on, attrs }"
                                          >
                                            <v-btn
                                              color="#e31084"
                                              fab
                                              small
                                              @click="visualizarFoto(item)"
                                              v-bind="attrs"
                                              v-on="on"
                                            >
                                              <v-icon style="color: white" small
                                                >photo_camera</v-icon
                                              >
                                            </v-btn>
                                          </template>
                                          <span>Visualizar Comprovativo</span>
                                        </v-tooltip>
                                        <v-btn
                                          style="margin-left: 20px"
                                          @click="removerImagem(item)"
                                          color="red"
                                          fab
                                          small
                                        >
                                          <v-icon style="color: white" small
                                            >delete</v-icon
                                          >
                                        </v-btn>
                                      </template>
                                    </v-data-table>
                                  </template>
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                          </v-tabs-items>
                        </v-col>
                      </v-row>
                    </v-container>
                    <small>Copyright - 2021 by Softline, Angola</small>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog = false">
                      Fechar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
          <!-- ====================================== CARD/================================================ -->
          <!--============= Anulação de documento --=========================================================== -->

          <template>
            <v-row justify="center">
              <v-dialog v-model="dialogAnular" max-width="590">
                <v-card>
                  <v-card-title style="background-color: #006699; color: white"
                    >Finalizar a anulação</v-card-title
                  >

                  <v-overlay :value="overlayAnulacao">
                    <v-progress-circular
                      indeterminate
                      size="64"
                    ></v-progress-circular>
                  </v-overlay>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-card-text>
                      <v-row>
                        <v-col md="6"
                          ><span>Anulação do Documento :</span></v-col
                        >
                        <v-col md="6"
                          ><span style="font-weight: bold">{{
                            editedItem !== null
                              ? editedItem.numeroDocumento
                              : ""
                          }}</span></v-col
                        >
                        <v-col md="6"><span>Criação do documento:</span></v-col>
                        <v-col md="6"
                          ><span style="font-weight: bold"
                            >Nota de Crédito NC-2022/01</span
                          ></v-col
                        >
                        <v-col md="6"><span>Motivo de anulação :</span></v-col>
                        <v-col md="12"
                          ><span style="font-weight: bold; color: red"
                            >ATT :</span
                          ><span>
                            O nome do autor da anulação e a data da anulação
                            serão armazenados.</span
                          ></v-col
                        >
                        <v-col md="12"
                          ><span
                            ><v-text-field
                              v-model="motivoAnulacao"
                              label="Informe aqui o motivo da anulação"
                              :rules="ruleRequired"
                            ></v-text-field></span
                        ></v-col>
                      </v-row>
                    </v-card-text>
                  </v-form>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="red darken-1"
                      text
                      @click="dialogAnular = false"
                    >
                      Cancelar
                    </v-btn>
                    <v-btn
                      color="green darken-1"
                      text
                      :disabled="!valid || motivoAnulacao === ''"
                      @click="showDialogConfirm()"
                    >
                      Finalizar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
          <!-- =========================Anulação de fatura - confirmação ================================================================= -->

          <!--================ EDITAR FACTURA ============================-->
          <template>
            <v-row justify="center">
              <v-dialog v-model="dialogoEditar" max-width="590">
                <v-card>
                  <v-card-title style="background-color: #006699; color: white"
                    >Editar Factura</v-card-title
                  >

                  <!-- <v-overlay :value="overlayAnulacao">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                  </v-overlay> -->
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-card-text>
                      <v-row>
                        <v-col md="6"><span>Número da factura :</span></v-col>
                        <v-col md="6"
                          ><span style="font-weight: bold">{{
                            editedItem !== null
                              ? editedItem.numeroDocumento
                              : ""
                          }}</span></v-col
                        >
                        <v-col md="6"><span>Criação do documento:</span></v-col>
                        <v-col md="6"
                          ><span style="font-weight: bold"
                            >Nota de Crédito NC-2022/01</span
                          ></v-col
                        >
                      </v-row>
                    </v-card-text>
                  </v-form>

                  <div class="combox_containers">
                    <div class="tpaCombox">
                      <v-combobox
                        v-model="tpaSelectedField"
                        :rules="ruleRequired"
                        label="Selecione a forma pagamento"
                        item-value="num_recibo"
                        item-text="num_recibo"
                        :items="tpas"
                        return-object
                        rounded
                      >
                        <template v-slot:item="{ item }">
                          <v-list-item-avatar
                            v-if="item.icone"
                            color="indigo"
                            class="headline font-weight-light white--text"
                          >
                            <v-btn icon fab
                              ><v-icon style="color: white">add</v-icon></v-btn
                            >
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title
                              v-text="item.descricao"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-combobox>
                    </div>
                  </div>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="red darken-1"
                      text
                      @click="dialogoEditar = false"
                    >
                      Cancelar
                    </v-btn>
                    <v-btn
                      color="green darken-1"
                      text
                      @click="editarFacturas()"
                    >
                      Finalizar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </template>

          <!-- ******************************************************************************** -->

          <v-dialog v-model="dialogComprovativo" max-width="1000">
            <listamComprovativo :file="file"></listamComprovativo>
          </v-dialog>
          <!-- *************************************************************************************** -->

          <!-- ================================================= ANEXAR COMPROVATIVOS ================================================ -->

          <template>
            <v-row justify="space-around">
              <v-col cols="auto">
                <v-dialog
                  persistent
                  transition="dialog-top-transition"
                  max-width="600"
                  v-model="dialogoAnexar"
                >
                  <v-card>
                    <v-overlay :value="overlayFicheiro">
                      <v-progress-circular
                        indeterminate
                        size="64"
                      ></v-progress-circular>
                    </v-overlay>
                    <v-toolbar color="primary" dark
                      >Anexar Imagem do comprovativo</v-toolbar
                    >
                    <v-card-text>
                      <v-row>
                        <v-col md="10">
                          <v-card
                            class="mx-auto"
                            style="height: 260px; margin-top: 30px"
                            tile
                          >
                            <v-list dense>
                              <v-subheader></v-subheader>
                              <v-list-item-group color="primary">
                                <v-list-item
                                  v-for="(item, i) in arrayFicheiros"
                                  :key="i"
                                >
                                  <v-list-item-content>
                                    <v-list-item-title
                                      v-text="item.descricao"
                                    ></v-list-item-title>
                                  </v-list-item-content>
                                  <v-list-item-icon @click="removeFile(item)">
                                    <v-icon style="color: red">delete</v-icon>
                                  </v-list-item-icon>
                                </v-list-item>
                              </v-list-item-group>
                            </v-list>
                          </v-card>
                          <small>* Selecione o ficheiro de FOTO</small>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                      <v-btn color="red" dark text @click="closeDialogoAnexar()"
                        >Fechar</v-btn
                      >
                      <v-btn
                        :disabled="!arrayFicheiros.length"
                        text
                        color="green"
                        dark
                        @click="salvarImage()"
                        >Salvar</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
          </template>
          <!-- ******************** ELIMINAR ********************************************************************************************************** -->

          <v-row justify="center">
            <v-dialog
              v-model="dialogConfirmarEliminacao"
              persistent
              max-width="550"
            >
              <v-card>
                <v-overlay :value="overlayConfirmar">
                  <v-progress-circular
                    indeterminate
                    size="64"
                  ></v-progress-circular>
                </v-overlay>
                <v-card-title class="headline"
                  >Desejas continuar com a operação?</v-card-title
                >
                <v-card-text
                  ><span style="font-size: 15px"
                    >Está prestes a eliminar a imagem de um comprovativo ,
                    <br /><span style="font-weight: bold"
                      >deseja continuar ?</span
                    ></span
                  ></v-card-text
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="red"
                    text
                    @click="dialogConfirmarEliminacao = false"
                    >Cancelar</v-btn
                  >
                  <v-btn color="green" text @click="confirmarEliminacao()"
                    >Continuar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>

          <!-- ======================================================================== -->

          <!-- ******************** ELIMINAR ********************************************************************************************************** -->

          <v-row justify="center">
            <v-dialog v-model="dialogAnularMulta" persistent max-width="550">
              <v-card>
                <v-overlay :value="overlayConfirmar">
                  <v-progress-circular
                    indeterminate
                    size="64"
                  ></v-progress-circular>
                </v-overlay>
                <v-card-title class="headline"
                  >Motivo da anulação da multa</v-card-title
                >
                <v-form
                  ref="formAnularMulta"
                  v-model="validAnularMulta"
                  lazy-validation
                >
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="12"
                        ><v-text-field
                          v-model="motivoAnularMulta"
                          label="Informe o motivo para anulação da multa"
                          :rules="ruleRequired"
                        >
                        </v-text-field
                      ></v-col>
                    </v-row>
                  </v-card-text>
                </v-form>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red" text @click="dialogAnularMulta = false"
                    >Cancelar</v-btn
                  >
                  <v-btn color="green" text @click="eliminarMulta(item_venda)"
                    >Continuar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>

          <!-- ======================================================================== -->
        </v-card>
      </div>
    </div>
  </div>
</template>
My CRUD
<script>
import Vue from "vue";
import axios from "../../plugins/axios";
import utilitarios from "../../plugins/utilitarios";
import listamComprovativo from "../fin-escola/pagamentoComponentes/listagemComprovativos.vue";
import { mask } from "vue-the-mask";
import Swal from "sweetalert2";
const ls = require("local-storage");
import impressaoUtilitario from "../../utilitarios/impressao.utilitario";
export default {
  directives: { mask },
  components: {
    listamComprovativo,
  },
  data: () => ({
    tpas: [],
    dialogoEditar: false,
    tpaSelectedField: null,

    motivoAnularMulta: "",
    validAnularMulta: false,
    item_venda: {},
    dialogAnularMulta: false,
    estudante: { curso: "", classe: "" },
    overlay: false,
    dialogAnular: false,
    overlayAnulacao: false,
    dialogComprovativo: false,
    dialogoAnexar: false,
    overlayFicheiro: false,
    overlayConfirmar: false,
    searchInDb: "",
    alert: false,
    iconAlert: "",
    alertType: "",
    motivoAnulacao: "",
    totalDebitoVar: 0,
    colorAlert: "",
    utilitarios: utilitarios,
    msgAlert: "",
    allowSpaces: false,
    arrayFicheiros: [],
    dropdowSexo: [
      { idSexo: "M", descricao: "Masculino" },
      { idSexo: "F", descricao: "Femenino" },
    ],
    tab: null,
    mesSelecionado: null,
    datebi: null,
    date: null,
    novo: false,
    progresso: false,
    img: "img/logo.jpeg", // 'https://images.pexels.com/photos/226746/pexels-photo-226746.jpeg', //'../../assets/dev.png',
    descricao: "Nº do Bi",
    valid: true,
    menu: false,
    txtCliente: null,
    comprovativos: [],
    clientes: [],
    meses: [],
    dispesasGeral: [],
    menubi: false,
    ano_actual: ls.get("anolectivo"),
    habilitaBi: false,
    dialogConfirmarEliminacao: false,
    startDate: null,
    cursos: [],
    isLoading: false,
    contaCorrente: [],
    turmasAll: [],
    servico: "",
    mascara: "#########-AA-###",
    turmasFiltered: [],
    municipiosAll: [],
    dispesas: [],
    produtos: [],
    file: "",
    cor: "",
    municipiosFiltered: [],
    provincias: [],
    itemObject: null,
    estudantes: [],
    recibos: [],
    servicos: [],
    itemsFatura: [],
    editedItemFicheiro: null,
    dialogGrupo: false,
    dialogTaxa: false,
    dialog: false,
    idd: false, // simula autoinclemet
    editedItem: null,
    TotalincidenciaIva: 0,
    TotalincidenciaIsento: 0,
    config: { logo: "img/logoAt.jpeg", descricao: "ISP-Atlântida" },
    couterIva: 0,
    counterIsento: 0,
    totalIliquido: 0,
    totalDesconto: 0,
    saldoEstudante: 0,
    totalImposto: 0,
    totalFactura: 0,
    saldoUsado: 0,
    y: "top",
    text: "mensagem nao setada.",
    tab: 0,
    lastInscricaoNaTurma: [],
    items: [
      { tab: "Emolumentos da Factura", icon: "list" },
      { tab: "Comprovativos carregados", icon: "photo_camera" },
    ],
    //  timeout: 4000,

    ruleRequired: [(value) => !!value || "campo obrigatorio"],
    ruleTextRequired: [
      (value) => !!value || "campo obrigatório.",
      (value) =>
        (value || "").length <= 50 || "O máximo número de carácters atigidos",

      (value) => (value || "").length > 3 || "carácteres insuficientes",
      (value) => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/;
        return !pattern.test(value) || "Invalido.";
      },
    ],
    ruleBI: [
      (value) => value.length === 16 || "Minimo de caracteres exigido( 16 ).",
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      (value) => value.length <= 50 || "O máximo número de carácters atigidos",
      (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
    ],
    headersTabela: [
      { text: "Descrição da dispesa", value: "dispesa" },
      { text: "Data da operação", value: "data_" },
      { text: "Categoria", value: "categoria" },
      { text: "Subcategoria", value: "subcategoria" },
      { text: "Tipo de dispesa", value: "tipo" },
      { text: "Custo", value: "custo" },
      { text: "Registrada por", value: "autor" },
      { text: "Selecione", value: "selecione" },
    ],
    headerComprovativos: [
      { text: "Nome do ficheiro", value: "nome" },
      { text: "Acções", value: "view" },
    ],
    headers: [
      { text: "Nº de Ordem.", value: "ordem" },
      { text: "Documento", value: "descricao" },
      { text: "Identificação do documento", value: "numeroDocumento" },
      { text: "Data", value: "data_" },
      { text: "Cliente", value: "cliente" },
      { text: "Nif", value: "nif" },
      { text: "Valor Ilíquido", value: "valorIliquido" },
      { text: "I.V.A", value: "iva" },
      { text: "Total", value: "valorAPagar" },
      { text: "Registrada por", value: "nomeUsuario" },
      { text: "Estado", value: "estado" },
      { text: "Opção", value: "action" },
    ],
    headersItems: [
      { text: "Nº de Ordem.", value: "ordem" },
      { text: "Produto", value: "produto" },
      { text: "Mês", value: "fkMes" },
      { text: "Preço Unit.", value: "precoUnitario" },
      { text: "Qtd", value: "qtd_venda" },
      { text: "I.V.A", value: "iva" },
      { text: "Multa", value: "multa" },
      { text: "Desconto de linha", value: "descontoLinha" },
      { text: "Subtotal", value: "subTotal" },
      { text: "Opcção", value: "action" },
    ],
  }),

  computed: {
    licencaExpirada() {
      return ls.get("licencaExpirada");
    },

    isTelaPagamento() {
      return window.location.href.includes("/esc-pagamento");
    },

    isAdminSoftline() {
      return (ls.get("nivel_user") === 1 ||  ls.get("nivel_user") === 7);
    },

    isLuena() {
      return (
        (window.location.host.includes("192.168.20.2") ||
          window.location.host.includes("localhost")) &&
        this.roleUsuario === "ROLE_AUS"
      );
    },

    isEsca() {
      return ls.get("i_id") === 17
        ? "../fin-escola/recibo-pagamento-escola-esca.vue"
        : "../fin-escola/recibo-pagamento-escola-ilha.vue";
    },

    IsNegecioEscola(){
      return ls.get('fkNegocio') == 12
    },

    

    ObterDataActural() {
      var date = new Date();
      let year = date.getFullYear();
      let month = (1 + date.getMonth()).toString().padStart(2, "0");
      let day = date.getDate().toString().padStart(2, "0");
      var date_ = year + "-" + month + "-" + day;
      return date_;
    },

    ObterHoraActual(today) {
      var time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      return time;
    },

    roleUsuario() {
      return ls.get("role");
    },

    formTitle() {
      return this.editedIndex === -1
        ? "Inser novo Estudante"
        : "Editar dados de Estudante";
    },
    loggedUserName() {
      return ls.get("nomeUsuario");
    },
    idclasse() {
      return this.$store.state.idclasse;
    },
    computeddatanascimento() {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento
        ? moment(this.editedItem.datanascimento).format("dddd, MMMM Do YYYY")
        : "";
    },
    computedDateFormattedDatefns() {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, "dddd, MMMM Do YYYY") : "";
    },
    textMessage() {
      return this.$store.state.textMessage;
    },
    classMessage() {
      return this.$store.state.classMessage;
    },

    isBendizer() {
      return window.location.host.includes("bendizer.net");
    },
    hasMessage() {
      return this.$store.state.hasMessage;
    },

    ListaActividades() {
      return ls.get("lista_actividades");
    },
    totalDebito() {
      let total = 0;
      this.dispesas.forEach((element) => {
        total += element.valorAPagar;
      });
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return total;
    },
    totalSaidas() {
      let saidas = 0;
      this.contaCorrente.forEach((element) => {
        saidas += parseInt(element.qtd_venda);
      });
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return saidas;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    // check if classe has been selected otherwise send back to painel to select
    this.initialize();
    this.initializeCursos();
    this.config = impressaoUtilitario.getConfig();
  },

  methods: {
    async initializeTPA() {
      this.tpaSelectedField = null;

      try {
        this.overlay = true;
        this.tpas = await axios.get("/tpasFindAll").then((res) => res.data);
        this.tpaSelectedField = this.tpas.filter(
          (f) => (f.id = this.editedItem.tpa)
        )[0];
      } catch (error) {
        Swal.fire(
          "Informação",
          "Ocorreu um erro ao carregar os dados dos TPAs",
          "error"
        );
      } finally {
        this.overlay = false;
      }
    },

    async editarFacturas() {
      this.overlay = true;
      try {
        let params = {
          idVenda: this.editedItem.pkVenda,
          idTpa: this.tpaSelectedField.id,
          descricaoTpa: this.tpaSelectedField.num_recibo,
        };

        let result = await axios
          .post("/actualizarFactura", params)
          .then((res) => res.data);

        if (result.affectedRows >= 1) {
          Swal.fire(
            "Informação",
            "<p>Factura editada com sucesso.</p>",
            "success"
          );
        } else {
          Swal.fire(
            "Erro",
            "<p>Erro durante a edição da factura.</p>",
            "error"
          );
        }
      } catch (error) {
        Swal.fire("Erro", "<p>Erro durante a edição da factura.</p>", "error");
      } finally {
        this.initialize();
        this.initializeCursos();
        this.config = impressaoUtilitario.getConfig();
        this.dialogoEditar = false;
        this.overlay = false;
      }
    },

    ObterData(data) {
      var date =
        data.getFullYear() + "-" + (data.getMonth() + 1) + "-" + data.getDate();
      return date;
    },

    async getTurmaOfStudentByMatricula(item) {
      ls.set("lastMAtriculaOfStudent", []);
      if (!this.isBendizer) {
        try {
          this.lastInscricaoNaTurma = await axios
            .post("/getLastTurmaOfStudentByMatricula", item)
            .then((res) => res.data);
        } catch (error) {
          console.log("err");
          this.isLoading = false;
          this.$store.dispatch("textMessage", {
            msg: error,
            classMessage: "msgError",
            timeout: 3000,
          });
        }
      }
    },

    change({ coordinates, canvas }) {
      // console.log(coordinates, canvas)
    },

    showDialogConfirm() {
      Swal.fire({
        title: "Anulação de factura",
        text: "Ao clicar em continuar, o processo de anulação de factura será finalizado, deseja continuar ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Continuar",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.AnulamentoDocumento();
        }
      });
    },

    async initializeCursos() {
      try {
        this.isLoading = true;
        this.cursos = await axios
          .get("/cursoInstituicaoFindAllIntegracao")
          .then((res) => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    },

    close() {},
    async confirmarEliminacao() {
      try {
        this.overlayConfirmar = true;
        let result = await this.DeleteImage({ item: this.editedItemFicheiro });
        if (result.affectedRows >= 1) {
          let index = this.comprovativos.indexOf(this.editedItemFicheiro);
          this.comprovativos.splice(index, 1);
        }
        this.dialogConfirmarEliminacao = false;
        this.overlayConfirmar = false;
      } catch (error) {
        this.overlayConfirmar = false;
        this.dialogConfirmarEliminacao = false;
        Swal.fire(
          "Informação",
          "<p>Ocorreu um erro ao tentar efectuar a operação.</p>",
          "error"
        );
      }
    },

    removerImagem(item) {
      this.dialogConfirmarEliminacao = true;
      this.editedItemFicheiro = item;
    },

    closeDialogoAnexar() {
      this.dialogoAnexar = false;
    },

    removeFile(item) {
      let index = this.arrayFicheiros.indexOf(item);
      this.arrayFicheiros.splice(index, 1);
    },

    async salvarImage() {
      this.overlayFicheiro = true;
      try {
        let params = {
          ficheiros: this.arrayFicheiros,
          guid: this.itemObject.guid,
        };

        let result = await this.saveImage(params);
        if (result.affectedRows >= 1) {
          Swal.fire(
            "Informação",
            "<p>Ficheiro(s) carregado(s) com sucesso. </p>",
            "success"
          );
          this.arrayFicheiros = [];
          this.dialogoAnexar = false;
          this.dialog = false;
        }
        this.overlayFicheiro = false;
      } catch (error) {
        this.overlayFicheiro = false;
        Swal.fire(
          "Informação",
          "<p>Ocorreu um erro ao tentar carregar a(s) imagem (s)</p>",
          "error"
        );
      }
    },

    previewImage: function (event) {
      // Reference to the DOM input element
      this.dialogoAnexar = true;
      var input = event.target;

      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format

        let type = input.files[0].type;
        if (
          type === "image/png" ||
          type === "image/jpg" ||
          type === "image/jpeg"
        ) {
          var reader = new FileReader();
          reader.readAsDataURL(input.files[0]);
          reader.onload = () => {
            // Read image as base64 and set to imageData
            this.imageData = reader.result;
            this.arrayFicheiros.push({
              descricao: input.files[0].name,
              file: this.imageData,
            });
          };
        } else {
          Swal.fire(
            "Informação",
            "<p>Ficheiro inválido, selecione por favor uma imagem dos formatos ( PNG,JPG,JPEG ).</p>",
            "warning"
          );
        }
      } else {
        this.imageData = "";
      }
    },

    visualizarFoto(item) {
      this.file = item.file;
      this.itemObject = item;
      this.dialogComprovativo = true;
    },

    async initialize() {
      if (!this.searchInDb) {
        var payload = '{"find":"all"}';
      } else {
        var payload = '{"find":"' + this.searchInDb + '"}';
      }

      try {
        this.progresso = true;
        this.dispesas = await axios
          .get("/VendasFindAll/" + payload)
          .then((res) => res.data);
        this.dispesasGeral = this.dispesas;
        this.progresso = false;
      } catch (error) {
        this.progresso = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },

    async saveImage(params) {
      return await axios.post("/saveImageFile", params).then((res) => res.data);
    },

    async DeleteImage(params) {
      return await axios.post("/eliminarImage", params).then((res) => res.data);
    },

    async CarregarItemsTabela(item) {     
      
       
      ls.set('hashFactura',utilitarios.ObterDigitosHashParaFactura(item.hash))
      ls.set("data_venda_factura", item.data_);
      ls.set("data_venda_factura_full", item.data_movimentacao);
      ls.set("resumoImposto",[])
      
      this.overlay = true;
      this.saldoUsado = item.saldoUsado;
      this.editedItem = item;
      this.itemObject = item;
      await this.getTurmaOfStudentByMatricula(item);
      await this.pesquisarStatusSaldo(item);
      this.comprovativos = await this.obterFicheiros(item.guid);
      this.itemsbypkVenda(item.pkVenda)
        .then((res) => {
          ls.set("pkVenda", item.pkVenda);
          this.CalculaTotais(res);
          this.calculaIncidencia(res);
          this.itemsFatura = res;
          this.overlay = false;
          this.dialog = true;
        })
        .catch((error) => {
          this.overlay = false;
        });
    },
    async eliminarMulta(item) {
      let pos = this.itemsFatura.indexOf(item);
      let posArrayDespesas = this.dispesas.indexOf(
        this.dispesas.filter((d) => d.pkVenda === item.fkVenda)[0]
      );

      if (this.$refs.formAnularMulta.validate()) {
        let valorIliquido = this.dispesas[posArrayDespesas].valorIliquido;
        item.motivoAnulacaoMulta = this.motivoAnularMulta;
        this.dialogAnularMulta = false;
        this.dispesas[posArrayDespesas].valorAPagar = valorIliquido;
        this.dispesas[posArrayDespesas].valorPago = valorIliquido;

        this.itemsFatura[pos].subTotal = valorIliquido;
        this.itemsFatura[pos].multa = 0;
        let anular = await axios
          .post("/anularMulta", item)
          .then((res) => res.data);
      }
    },

    async CallApiEmail(corpo, destino) {
      try {
        await axios({
          method: "post",
          url: "http://restrito.softlineangola.com:3000/api/enviarEmail",
          data: {
            corpo: corpo,
            destino: destino,
          },
        }).then();
        // Imprimir PDF
      } catch (error) {
        Swal.fire(
          "Informação",
          "Ocorreu um erro ao tentar enviar o e-mail",
          "error"
        );
      }
    },

    async obterFicheiros(guid) {
      return await axios
        .post("/obterFicheirosbyGuid", { guid: guid })
        .then((res) => res.data);
    },

    CalculaTotais(items) {
      items.forEach((element) => {
        this.totalIliquido += parseInt(element.precoUnitario);
        this.totalDesconto += parseInt(element.descontoLinha);
      });
    },

    calculaIncidencia(items) {
      items.forEach((element) => {
        if (element.iva > 0) {
          this.couterIva++;
          this.TotalincidenciaIva += parseInt(element.precoUnitario);
        } else if (
          element.iva === 0 ||
          element.iva === null ||
          element.iva === undefined
        ) {
          this.counterIsento++;
          this.TotalincidenciaIsento += parseInt(element.precoUnitario);
        }
      });

      // Calcula total de imposto
      this.totalImposto += utilitarios.ObterValorDaPercentagem(this.TotalincidenciaIva, 14);
    },
    async itemsbypkVenda(pkVenda) {
      try {
        return await axios
          .get("/itemsFactura/" + pkVenda)
          .then((res) => res.data);
      } catch (error) {
        this.progresso = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },

    async pesquisarStatusSaldo(item) {
      try {
        let params = {
          idCliente: item,
        };

        let result = await axios
          .post("/ObterStatusSaldoAlunoNovo", params)
          .then((res) => res.data);
        if (result.saldo) {
          this.saldoEstudante = result.saldo;
        } else {
          this.saldoEstudante = 0;
        }
      } catch (error) {
        // console.log(error);
      }
    },

    Impressao() {
      if (this.licencaExpirada) {
        Swal.fire(
          "Informação",
          "A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!",
          "info"
        );
      } else {
        try {

           
          this.$store.state.loading_pdf = true;

          // Caso existir o emolumento confirmação nos items então a turma será N/A
          // caso contrario exibirá  a turma da última matricula confirmada

          let existeConfirmacao = this.itemsFatura.filter((i) =>
            i.produto.includes("Confirmação")
          );

          console.log(this.lastInscricaoNaTurma, ' a last, G');
          
          let lastInscricao = this.lastInscricaoNaTurma;
          lastInscricao = this.lastInscricaoNaTurma.length
            ? this.lastInscricaoNaTurma[0]
            : { turma: "N/A" };


             

          ls.set("lastMAtriculaOfStudent", lastInscricao);
          ls.set("saldo", this.saldoEstudante);
          ls.set("saldoUsando", this.saldoUsado);
          ls.set("itemsFaturaEstaticos", this.editedItem);
          ls.set("itemsFatura", this.itemsFatura);
          ls.set("bolseiro", []);
          ls.set("totais", {
            totalIliquido: this.totalIliquido,
            totalDesconto: this.totalDesconto,
            totalImposto: this.totalImposto,
            totalFatura: this.totalIliquido + this.totalImposto,
          });
          ls.set(
            "curso",
            this.cursos.filter(
              (c) => c.idCurso === parseInt(this.editedItem.idCurso)
            )[0].descricao
          );
          let tabelaIncidencia = [];
          ls.remove('resumoImposto')
          // tabelaIncidencia.push({
          //   qtdIsento: this.counterIsento,
          //   totalIncidenciaIsento: this.TotalincidenciaIsento,
          //   totalIncidenciaIva: this.TotalincidenciaIva,
          //   qtdIva: this.couterIva,
          //   totalIva: this.totalImposto,
          // });

          if( this.couterIva > 0 ){ // insere o total iva

              tabelaIncidencia.push({
                qtdIsento: 0,
                totalIncidenciaIsento: 0,
                incidencia: this.TotalincidenciaIva,
                qtdIva: this.couterIva,
                totalIva: this.totalImposto,
              });

          }if( this.counterIsento > 0 ){
                tabelaIncidencia.push({
                qtdIsento: this.counterIsento,
                 incidencia: this.TotalincidenciaIsento,
                qtdIva: 0,
                totalIva: 0,
              });
          }

          ls.set("resumoImposto", tabelaIncidencia);
          if (
            this.editedItem !== null &&
            this.editedItem.estado === "Anulada"
          ) {
            this.$router.push("gerar-fatura-anulada");
          } else {
            /*
              Esse trecho de código, imprimirRecibo(), carrega dinamicamente o componente de 
              uma segunda página chamada "recibo-pagamento-escola.vue" e o monta em uma instância 
              temporária do Vue. Isso permite que você exiba e imprima um recibo de pagamento da 
              escola sem interferir na página atual.
            */
           

            if (this.IsNegecioEscola) {
              import("../fin-escola/recibo-pagamento-escola-esca.vue").then(
                (module) => {
                  const SegundaPagina = module.default;
                  const tempInstance = new Vue({
                    render: (h) => h(SegundaPagina),
                  });
                  tempInstance.$mount();
                }
              );
            } else {
              import("../fin-escola/recibo-pagamento-empresas.vue").then(
                (module) => {
                  const SegundaPagina = module.default;
                  const tempInstance = new Vue({
                    render: (h) => h(SegundaPagina),
                  });
                  tempInstance.$mount();
                }
              );
            }

          }
        } catch (error) {
          this.$store.state.loading_pdf = false;
          Swal.fire(
            "Informação",
            "Ocorreu um erro durante a impressão do documento.",
            "info"
          );
        }
      }
    },

    showAnularDocumento() {
      this.dialog = false;
      this.dialogAnular = true;
    },

    showEditarDocumento() {
      this.dialog = false;
      this.initializeTPA();
      this.dialogoEditar = true;
    },

    async AnulamentoDocumento() {
      if (this.$refs.form.validate()) {
        this.overlayAnulacao = true;
        try {
          let results = await axios
            .post("/anularDocumento", {
              items: this.itemsFatura,
              motivo: this.motivoAnulacao,
              factura: this.editedItem,
              autor: this.loggedUserName,
              serie: this.editedItem.serie,
            })
            .then((res) => res.data);
          this.overlayAnulacao = false;
          if (results.affectedRows >= 1) {
            let corpo =
              `<span style="color:red;font-size:16px;">** Não responder à este e-mail**</span><br>
             <span>Foi anulada a Factura Recibo ` +
              this.editedItem.numeroDocumento +
              `,com os seguintes detalhes:</span><br><br>
             <span style="font-weight:bold;">Código Interno: </span><span>` +
              this.editedItem.pkVenda +
              `</span><br>
             <span style="font-weight:bold;">Cliente/Estudante: </span><span>` +
              this.editedItem.cliente +
              `</span><br>
             <span style="font-weight:bold;">Autor da anulação: </span><span>` +
              this.loggedUserName +
              `</span><br>
             <span style="font-weight:bold;">Data da anulação: </span><span>` +
              this.ObterData(new Date()) +
              `</span><br>
             <span style="font-weight:bold;">Origem: </span><span>` +
              this.config.descricao +
              `</span><br>
             <span style="font-weight:bold;">Motivo da anulação: </span><span>` +
              this.motivoAnulacao +
              `</span><br>
            `;
            // this.CallApiEmail(corpo,'logsoftline@gmail.com')
            this.overlayAnulacao = false;
            this.dialogAnular = false;
            Swal.fire(
              "Informação",
              "<p>Factura anulada com sucesso.</p>",
              "success"
            );
            // this.$router.push('gerar-notaCredito')
            this.initialize();
          } else {
            Swal.fire(
              "Informação",
              "<p>Ocorreu um erro ao tentar efectuar a operação.</p>",
              "error"
            );
          }
        } catch (error) {
          this.overlayAnulacao = false;
          this.text = error;
          this.$store.dispatch("textMessage", {
            msg: this.text,
            classMessage: "msgError",
            timeout: 3000,
          });
        }
      }
    },
  },
};
</script>
<style scoped>
.pagamento_feito {
  color: green;
  margin: 10px auto;
  font-weight: bold;
}

.tpaCombox {
  height: 55px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 5px;
  margin-left: 10px;
}

.combox_containers {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 10px;
  margin-bottom: 5px;
}
</style>